import { Component } from '@angular/core';
import { nav_path } from 'src/app/app-routing.module';
import { SeoService } from '../../../core/services/seo.service';

@Component({
  selector: 'anon-home',
  templateUrl: 'home.component.html',
  styleUrls: ['home.component.scss']
})
export class HomeComponent {
  public readonly nav_path = nav_path;
  private title = "Home page";

  constructor(private seo: SeoService) {
    seo.generateTags({
      title: this.title,
      description: `Anonymous Systems ${this.title}`,
      route: nav_path.home
    });
  }
}
